function toggleMenu() {
  document.getElementById("fullscreenMenu").classList.toggle("active");
}

document.addEventListener("DOMContentLoaded", function () {

  // =========================
  // LENIS SMOOTH SCROLL
  // =========================
  const lenis = new Lenis({
    duration: 1.5,
    smooth: true,
    smoothTouch: false
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // =========================
  // GSAP SETUP
  // =========================
  gsap.registerPlugin(ScrollTrigger);

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });

  gsap.ticker.lagSmoothing(0);

  // =========================
  // FADE UP
  // =========================
  gsap.utils.toArray('.animat-text').forEach((block) => {

  const items = block.querySelectorAll('h1, h2, p');

  gsap.from(items, {
    y: 60,
    opacity: 0,
    stagger: 0.2, // ye sequence control karta hai
    duration: 1,
    ease: "power3.out",
    scrollTrigger: {
      trigger: block,
      start: "top 85%",
      toggleActions: "play reverse play reverse"
    }
  });

});

  // =========================
  // FADE IN
  // =========================
  gsap.utils.toArray('.gsap-fade-in').forEach((el) => {
    gsap.from(el, {
      opacity: 0,
      duration: 1,
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play reverse play reverse"
      }
    });
  });


  // =========================
  // IMAGE REVEAL
  // =========================
  gsap.utils.toArray('.gsap-image').forEach((el) => {
    const img = el.querySelector('img');
    if (!img) return;

    gsap.from(img, {
      scale: 1.2,
      duration: 1.5,
      ease: "power3.out",
      scrollTrigger: {
        trigger: el,
        start: "top 85%",
        toggleActions: "play reverse play reverse"
      }
    });
  });

  // =========================
  // PARALLAX
  // =========================
  gsap.utils.toArray('.gsap-parallax').forEach((el) => {
    const img = el.querySelector('img');
    if (!img) return;

    gsap.to(img, {
      y: -120,
      ease: "none",
      scrollTrigger: {
        trigger: el,
        scrub: true
      }
    });
  });


});


// Cursor Follow Images
document.addEventListener("DOMContentLoaded", function () {

  const section = document.querySelector('.cursor-section');
  const images = document.querySelectorAll('.cursor-img');

  let isActive = false;

  // Check section visibility
  ScrollTrigger.create({
    trigger: section,
    start: "top center",
    end: "bottom center",
    onEnter: () => isActive = true,
    onLeave: () => isActive = false,
    onEnterBack: () => isActive = true,
    onLeaveBack: () => isActive = false,
  });

  section.addEventListener("mousemove", (e) => {
    if (!isActive) return;

    const rect = section.getBoundingClientRect();

    // Normalize mouse position (-1 to 1)
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;

    images.forEach((img, index) => {

      const moveX = x * 20 * (index + 1) * 0.2; // very small movement
      const moveY = y * 20 * (index + 1) * 0.2;

      gsap.to(img, {
        x: moveX,
        y: moveY,
        duration: 1.2,
        ease: "power3.out"
      });

    });

  });

});


$(document).ready(function () {
  $('.gallery-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: true,

    prevArrow: `
      <button type="button" class="slick-prev">
        <img src="https://cdn.shopify.com/s/files/1/0977/9275/4011/files/previous_1.svg?v=1778479654" alt="Previous">
      </button>
    `,

    nextArrow: `
      <button type="button" class="slick-next">
        <img src="https://cdn.shopify.com/s/files/1/0977/9275/4011/files/next_1.svg?v=1778479654" alt="Next">
      </button>
    `,

    responsive: [
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
});